import employeeJoinMethod from './employee-join-method.json';

export default {
  employeeJoinMethod,
};
